import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "au-alert-error",
  role: "alert"
}
const _hoisted_2 = ["onSubmit"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_form_field = _resolveComponent("bs5-form-field")!
  const _component_bs5_cancel_button = _resolveComponent("bs5-cancel-button")!
  const _component_bs5_save_button = _resolveComponent("bs5-save-button")!
  const _component_bs5_base_modal = _resolveComponent("bs5-base-modal")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    as: "",
    "validation-schema": _ctx.schema
  }, {
    default: _withCtx(({ meta, handleSubmit }) => [
      _createVNode(_component_bs5_base_modal, {
        title: _ctx.$t('account.title'),
        visible: _ctx.visible,
        onClose: _ctx.closeModal
      }, {
        default: _withCtx(() => [
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-exclamation-circle-fill" }, null, -1)),
                _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("form", {
            novalidate: "",
            onSubmit: _withModifiers(($event: any) => (handleSubmit($event, _ctx.changePassword)), ["prevent"])
          }, [
            _createVNode(_component_bs5_form_field, {
              id: "currentPassword",
              name: "oldPassword",
              type: "password",
              icon: "bi-lock",
              autocomplete: "current-password",
              label: _ctx.$t('account.currentPassword'),
              modelValue: _ctx.form.oldPassword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.oldPassword) = $event))
            }, null, 8, ["label", "modelValue"]),
            _createVNode(_component_bs5_form_field, {
              id: "newPassword",
              name: "newPassword",
              type: "password",
              icon: "bi-key",
              autocomplete: "new-password",
              label: _ctx.$t('account.newPassword'),
              hint: _ctx.$t('account.policy'),
              modelValue: _ctx.form.newPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.newPassword) = $event))
            }, null, 8, ["label", "hint", "modelValue"]),
            _createVNode(_component_bs5_form_field, {
              id: "confirmNewPassword",
              name: "confirmNewPassword",
              type: "password",
              icon: "bi-key",
              autocomplete: "new-password",
              label: _ctx.$t('account.confirmPassword'),
              modelValue: _ctx.form.confirmNewPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.confirmNewPassword) = $event))
            }, null, 8, ["label", "modelValue"]),
            _cache[4] || (_cache[4] = _createElementVNode("button", {
              type: "submit",
              class: "d-none",
              tabindex: "-1",
              "aria-hidden": "true"
            }, null, -1))
          ], 40, _hoisted_2)
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_bs5_cancel_button, { onClick: _ctx.closeModal }, null, 8, ["onClick"]),
          _createVNode(_component_bs5_save_button, {
            loading: _ctx.saving,
            disabled: !meta.valid,
            onClick: ($event: any) => (handleSubmit($event, _ctx.changePassword))
          }, {
            default: _withCtx(() => [
              _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-check2" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t("account.changePassword")), 1)
            ]),
            _: 2
          }, 1032, ["loading", "disabled", "onClick"])
        ]),
        _: 2
      }, 1032, ["title", "visible", "onClose"])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}